// 引入 axios
import axios from "axios";

let BASEURL = '/portal';
/*const IMAGE_URL = "http://grdfb0a9-5001-default-172.25.10.169.nip.io/prod-api"*/
/*验证服务器*/
/*const IMAGE_URL = "http://182.92.143.198:8081"*/
/*正式服务器*/
/*http直接用这个地址*/
/*const IMAGE_URL = "http://8.140.28.85:8081"*/
/*https走80端口所以只能通过80转发 nginx里面加了针对/profile*/
const IMAGE_URL = "https://www.yzcx.cc"
//传送json格式的get请求
export const getRequest = (url, params) => {
    return axios({
        method: 'get',
        url: `${BASEURL}${url}`,
        data: params,
    })
}
export const imageTran = (path) => IMAGE_URL + path

export const fileTran = (path) => IMAGE_URL + path
